import { useEffect } from 'react';
import { holdStaleReload, type StaleReloadHold } from '../../../../shared-web/stale-bundle-reload';

/** While `held`, a newer deploy waits (or, for 'warn', is announced first). */
export function useStaleReloadHold(held: boolean, kind: StaleReloadHold = 'wait'): void {
  useEffect(() => (held ? holdStaleReload(kind) : undefined), [held, kind]);
}
